import * as React from 'react';
import { IntroText } from './IntroText/IntroText';
import './Home.css';

export let Home = () => {
    return (
      <div className="Home">
        <IntroText />
      </div>
    );
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/home/Home.tsx